import type { AqeTokenConfig } from '@pushly/aqe'
import type { WhitelabelConfigModel } from '../models/whitelabel-config/whitelabel-config.model'

/**
 * Convert WhitelabelConfigModel to Ant Design token overrides
 * This adapter bridges the existing white-label system with the new token system
 */
export function convertWhiteLabelToTokens(whiteLabelConfig: WhitelabelConfigModel | null): Partial<AqeTokenConfig> {
    if (!whiteLabelConfig) {
        return {}
    }

    const tokenConfig: Partial<AqeTokenConfig> = {
        token: {},
        components: {},
    }

    const colorConfig = whiteLabelConfig.getColorConfig()

    if (colorConfig) {
        // Use v2 color config if available
        if (colorConfig.secondaryHex) {
            tokenConfig.token!.colorPrimary = colorConfig.secondaryHex
        }

        // if (colorConfig.primaryHex) {
        //     tokenConfig.token!.colorInfo = colorConfig.primaryHex
        // }

        if (colorConfig.primaryButtonHex) {
            tokenConfig.components!.Button = {
                colorPrimary: colorConfig.primaryButtonHex,
            }
        }

        if (colorConfig.tabHex) {
            tokenConfig.components!.Tabs = {
                inkBarColor: colorConfig.tabHex,
                itemSelectedColor: colorConfig.tabHex,
            }
        }

        if (colorConfig.switchHex) {
            tokenConfig.components!.Switch = {
                colorPrimary: colorConfig.switchHex,
            }
        }
    } else {
        // Fallback to legacy color fields
        const primaryColor = whiteLabelConfig.getPrimaryColorHex()
        const secondaryColor = whiteLabelConfig.getSecondaryColorHex()

        if (primaryColor) {
            tokenConfig.token!.colorPrimary = primaryColor
        }

        if (secondaryColor) {
            tokenConfig.token!.colorInfo = secondaryColor
            tokenConfig.components!.Button = {
                colorPrimary: secondaryColor,
            }
            tokenConfig.components!.Tabs = {
                inkBarColor: secondaryColor,
                itemSelectedColor: secondaryColor,
            }
            tokenConfig.components!.Switch = {
                colorPrimary: secondaryColor,
            }
        }
    }

    return tokenConfig
}
